import SectionName from '~/constants/new-cars/SectionName';
import lookupSelection from './lookupSelection';
import type { ConfiguratorState } from '../configuratorState';

export default function getRestorationTarget(
  state: ConfiguratorState,
  sections: SectionName[]
): SectionName | undefined {
  for (let i = sections.length - 1; i >= 0; i--) {
    if (lookupSelection(state, sections[i])) {
      return sections[i + 1] ?? sections[i];
    }
  }

  return undefined;
}
